import React, { Component } from 'react';
import axios from 'axios';
import { API_URL } from '../../partials/Globals';
import Errors from '../../partials/Errors';

export default class NewGroupForm extends Component {
    state = {
        name: '',
        errors: ''
    }

    constructor(props) {
        super(props);

        this.inputChange = this.inputChange.bind(this);
        this.submit = this.submit.bind(this);
    }

    inputChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    submit(event) {
        event.preventDefault();
        var self = this;

        axios.post(API_URL+'/admin/groups', {
            name: this.state.name,
            school_id: this.props.id
        })
        .then(response => {
            // Uppdatera förälder-component
            this.props.update();
        })
        .catch(error => {
            // Valideringsfel
            if (error.response && error.response.status === 422) {
                self.setState({ errors: error.response.data }); 
            }
            // Annat fel
            if (error.response && error.response.status === 400) {
                self.setState({ errors: {1: 'Någonting gick fel, var god försök igen.'} })
            }
        });
    }
    
    render() {
        return (
            <div className="inline-form">
                <Errors errors={ this.state.errors } />

                <h1>Lägg till grupp</h1>

                <form onSubmit={ this.submit }>
                    <label>Namn</label>
                    <input type="text" name="name" value={ this.state.name } onChange={ this.inputChange } />
                    <input className="button purple" type="submit" value="Spara" />
                </form>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/superadmin/School/NewGroupForm.js